import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useNavigate, useParams} from "react-router-dom";
import {
   
    Link
  } from "react-router-dom";

const SearchFahrzeug = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [mengen, setMengen] = useState({});          // { [ArtikelNummer]: "12" }
const [sending, setSending] = useState({});        // { [ArtikelNummer]: true/false }
  const [modalShow, setModalShow] = useState(true);
  const [ModalTable, setModalTable] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [suche, setSuche] = useState(false);
  const [loading, setLoading] = useState(false);
  const [daten, setDaten] = useState([]);
  const [TableDaten, setTableDaten] = useState([]);
  const [searchfield, setSearchfield] = useState('');
  const [vertrag, setvertrag] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {  
    
    if (localStorage.getItem("loginData") == null) {
            
      navigate("/dhworld/login");
      
    } 
}, []);

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const search = async () => {
    if (searchfield.trim() === '') return;
    setLoading(true);
    setModalShow(false);
    setSuche(true);
    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/searchFahrzeug.php', {
        params: { searchfield, id }
      });
      setDaten(res.data.daten);
      //setLoading(false);
    } catch (err) {
      if (err.response?.status === 500) {
        //alert('There was a problem with the server');
      } else {
        //alert(err.response?.data?.msg || 'Ein Fehler ist aufgetreten');
      }
    } finally {
      setLoading(false);
    }
  };




  const handleClear = () => {
    setSearchfield('');
    setDaten([]);
    setSuche(false);
  };

  const setMengeFor = (artikelnummer, value) => {
    setMengen(prev => ({ ...prev, [artikelnummer]: value }));
  };
  
  const sendeLagerkorrektur = async (v) => {
    const artikelnummer = v.ArtikelNummer;
    const menge = mengen[artikelnummer];
  
    if (!menge || String(menge).trim() === "") {
      alert("Bitte Menge eingeben.");
      return;
    }
  
    setSending(prev => ({ ...prev, [artikelnummer]: true }));
    try {
      // KFZ / Lagernummer aus deinem Screen:
      // id = 443 (aus Route), Lagerort = "KN-DH 443"
      const kfz = `KN-DH ${id}`;
      const lagernummer = v.LagerNummer;
  
      await axios.post("https://dhworld.dietenmeier-harsch.de/lagerkorrektur_mail.php", {
        kfz,
        lagernummer,
        artikelnummer,
        menge
      }, {
        headers: { "Content-Type": "application/json" }
      });
  
      toast.success(`Meldung ans Lager gesendet.`);
      // Optional: Feld leeren
      setMengen(prev => ({ ...prev, [artikelnummer]: "" }));
    } catch (err) {
      console.error(err);
      toast.error("Fehler beim Senden. Bitte erneut versuchen.");
    } finally {
      setSending(prev => ({ ...prev, [artikelnummer]: false }));
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#eceff2',
        minHeight: '100vh',
      }}
      className="container-fluid"
    >
         <ToastContainer position="top-center" autoClose={2500} />
      <div className="row pt-4">
        <div className='col-12'>
        <Link
            to="/insight">
        <i style={{fontSize: '25px'}} class="bi bi-arrow-return-left"></i> <br></br><br></br>
        </Link>

          {/* Lupe mit Suchtext und X (nur wenn gesucht und Suchfeld nicht leer) */}
          {suche && searchfield.trim() !== '' && (
            <Row style={{background: '#fff', border: '1px solid #e6e8ed', boxshadow: '0 2px 4px #00000012', height: '5.2rem'}}>
              <Col xs={1}>
                <i  className="bi bi-search" style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }} onClick={() => setModalShow(true)}></i>
              </Col>
              <Col style={{}} xs={1}>
                Suche: {searchfield}
              </Col>
              <Col xs={1}>
                <i className="bi bi-x-lg" style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }} onClick={handleClear}></i>
              </Col>
            </Row>
          )}

          {/* Loading oder Ergebnisse / Info */}
          {loading ? (
            <Row>
              <Col xs={12} className="text-center">
                <Spinner animation="border" variant="primary" />
              </Col>
            </Row>
          ) : !suche || searchfield.trim() === '' ? (
            <div>
              <h3 style={{ fontWeight: 'bold' }}>Es wurde noch kein Suchbegriff eingegeben.</h3>
              <p>Klicken Sie auf die Lupe, um zu suchen.</p>
              <i className="bi bi-search" style={{ fontSize: '1.5rem', cursor: 'pointer' }} onClick={() => setModalShow(true)}></i>
            </div>
          ) : (
            <div>

                <br></br>

              <Row className="g-4">
  {daten && daten.length > 0 ? (
    daten.map((v, index) => (
<Col style={{ cursor: 'pointer' }} key={index} md={4}>
  <div
    style={{
      background: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      height: '100%',
      overflow: 'hidden',          // wichtig: Bild bündig + runde Ecken
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Bild bündig oben */}
    <div
      style={{
        width: '100%',
        height: '180px',
        background: '#f3f5f7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: '1px solid #e6e8ed',
        cursor: v.bild ? 'pointer' : 'default',
      }}
      onClick={() => v.bild && window.open(`https://dhworld.dietenmeier-harsch.de/datenn/${v.bild}`, '_blank')}
      title={v.bild ? 'Bild öffnen' : 'Kein Bild vorhanden'}
    >
      {v.bild ? (
        <img
          src={`https://dhworld.dietenmeier-harsch.de/datenn/${v.bild}`}
          alt={v.ArtikelNummer}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',     // bündig, ohne Verzerren
            display: 'block',
          }}
          loading="lazy"
        />
      ) : (
        <i className="bi bi-image text-secondary" style={{ fontSize: 42 }} />
      )}
    </div>

    {/* Inhalt mit Padding */}
    <div style={{ padding: '1rem', flex: 1 }}>
      <p><strong>Artikelnummer:</strong> {v.ArtikelNummer}</p>
      <div className="d-flex align-items-end gap-2 mt-3">
  <Form.Group className="mb-0" style={{ flex: 1 }}>
    <Form.Label className="mb-1"><strong>Menge im KFZ</strong></Form.Label>
    <Form.Control
      type="number"
      min="0"
      step="1"
      value={mengen[v.ArtikelNummer] ?? ""}
      onChange={(e) => setMengeFor(v.ArtikelNummer, e.target.value)}
      placeholder="z.B. 3"
    />
  </Form.Group>

  <button
    className="btn btn-primary"
    style={{ height: "38px" }}
    disabled={!!sending[v.ArtikelNummer]}
    onClick={() => sendeLagerkorrektur(v)}
  >
    {sending[v.ArtikelNummer] ? "Sende..." : "Absenden"}
  </button>
</div> <br></br>
      <p><strong>Bestand:</strong> {v.MengeBestand}</p>
      <p><strong>Bestelleinheit:</strong> {v.BestellEinheit}</p>
      <p><strong>Lagerort:</strong> {v.Lagerort}</p>
      <p><strong>Menge Mindestbestand:</strong> {v.MengeMindestBestand}</p>
      <p><strong>Menge Maximalbestand:</strong> {v.MengeMaximalBestand}</p>
      <p><strong>Schublade + Fach:</strong> {v.Disponent}</p>
      <p><strong>Artikelreferenz:</strong> {v.Art_Referenz}</p>
      <p><strong>Bezeichnung 1:</strong> {v.Art_Bezeichnung1}</p>
      <p><strong>Bezeichnung 2:</strong> {v.Art_Bezeichnung2}</p>

      <div className="d-flex align-items-center gap-2">
        <strong>Hauptlager geführt:</strong>
        <Form.Check
          type="checkbox"
          disabled
          checked={String(v.Art_Lagerartikel) === "1"}
          readOnly
        />
      </div>

      <br />
      <p><strong>Hinweis:</strong> {v.ART_InternerHinweis}</p>

      {/* optional: kleines Icon zum Öffnen (zusätzlich zum Klick auf Bild) */}
      <div className="d-flex align-items-center gap-2">
        <strong>Bild:</strong>
        {v.bild ? (
          <i
            className="bi bi-box-arrow-up-right"
            style={{ cursor: 'pointer', color: '#1245fb' }}
            onClick={() => window.open(`https://dhworld.dietenmeier-harsch.de/datenn/${v.bild}`, '_blank')}
            title="Bild öffnen"
          />
        ) : (
          <span className="text-secondary">kein</span>
        )}
      </div>
    </div>
  </div>
</Col>
    ))
  ) : (
    <Col xs={12}>
      <div style={{ background: '#fff', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
        Keine Daten gefunden
      </div>
    </Col>
  )}
</Row>
             
            </div>
          )}
        </div>
      </div>

      {/* Suchmodal */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Artikel suchen
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingBottom: '60px' }}>
          <div
            style={{
              backgroundColor: '#eceff2',
              padding: '20px',
              borderRadius: '8px',
              cursor: 'text',
              borderBottom: inputFocused ? '3px solid #66bfff' : '3px solid #ccc',
              transition: 'border-color 0.3s ease',
            }}
            onClick={focusInput}
          >
            <Form onSubmit={(e) => {
              e.preventDefault();
              search();
            }}>
              <Form.Group controlId="exampleForm.ControlInput1" style={{ marginBottom: '0' }}>
                <Form.Control
                  ref={inputRef}
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                  style={{
                    backgroundColor: 'transparent',
                    fontSize: '1.4rem',
                    border: 'none',
                    boxShadow: 'none',
                    outline: 'none',
                  }}
                  type="text"
                  placeholder="Suchbegriff eingeben"
                  value={searchfield}
                  onChange={(e) => setSearchfield(e.target.value)}
                />
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>





      <Modal size="lg" show={ModalTable}   onHide={() => setModalTable(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Detailanzeige zu Vertragsnummer {vertrag}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row>
        {TableDaten && TableDaten.length > 0 ? (
        <Col xs={12}>

        <Table striped responsive bordered hover>
      <thead>
        <tr>
        <th>Kundennummer</th>
        <th>Anrede</th>
        <th>Name</th>
        <th>Vorname</th>
        <th>Gebäude</th>
        <th>Kommission 1</th>
        <th>Kommission 2</th>
        <th>Status Vertrag</th>
        <th>Gebäude-Komplex</th>
        <th>Winter/Sommer</th>
        <th>Kompetenzstufe</th>
        </tr>
        </thead>
        <tbody>
        {
  
      
     
  TableDaten.map((v, index) => (
  <tr>
    <td>{v.KundeKundenNr}</td>
    <td>{v.KundeAnrede}</td>
    <td>{v.KundeName1}</td>
    <td>{v.KundeName2}</td>
    <td>{v.WAV_Gebaeude}</td>
    <td>{v.WAV_Kommission1}</td>
    <td>{v.WAV_Kommission2}</td>
    <td>{v.WAV_AktivPassivStatus}</td>
    <td>{v.WAV_GeabeudeKomplex}</td>
    <td>{v.Zeit}</td>
    <td>{v.Art}</td>
  </tr>

  ))}
  </tbody>
        </Table>
        </Col> ) : (
            <Col className='text-center' xs={12}>
<h3>Es sind keine weiteren Details verfügbar</h3>
            </Col>
        )
}
        </Row>

 </Modal.Body>
      </Modal>
    </div>
  );
};

export default SearchFahrzeug;
